import { render, staticRenderFns } from "./SafeBalanceActivityList.vue?vue&type=template&id=52448642"
import script from "./SafeBalanceActivityList.vue?vue&type=script&lang=js"
export * from "./SafeBalanceActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports